import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { bearing } from '@turf/bearing';
import { FeatureProperties } from '../constants';

/**
 * Custom simple_select mode that extends the default simple_select mode
 * to add origin (X) and end (arrow) markers for measurement lines.
 */
const SimpleSelectWithMeasurement = { ...MapboxDraw.modes.simple_select };

SimpleSelectWithMeasurement.toDisplayFeatures = function (
    state: any,
    geojson: any,
    display: (arg0: any) => void
) {
    // Call the default simple_select toDisplayFeatures
    MapboxDraw.modes.simple_select.toDisplayFeatures.call(
        this,
        state,
        geojson,
        display
    );

    // Add origin (X) and end (arrow) markers for measurement lines
    if (
        geojson.properties.user_meta === FeatureProperties.MEASUREMENT_LINE &&
        geojson.geometry.type === 'LineString' &&
        geojson.geometry.coordinates.length >= 2
    ) {
        const coords = geojson.geometry.coordinates;
        const start = coords[0];
        const end = coords[coords.length - 1];
        const lineBearing = bearing(start, end);

        display({
            type: 'Feature',
            properties: {
                meta: FeatureProperties.MEASUREMENT_LINE_ORIGIN,
                active: geojson.properties.active
            },
            geometry: {
                type: 'Point',
                coordinates: start
            }
        });

        display({
            type: 'Feature',
            properties: {
                meta: FeatureProperties.MEASUREMENT_LINE_END,
                bearing: lineBearing,
                active: geojson.properties.active
            },
            geometry: {
                type: 'Point',
                coordinates: end
            }
        });
    }
};

export default SimpleSelectWithMeasurement;
